module.exports = __webpack_public_path__ + "assets/img/yl_w_d_i_19.546d2d9e.jpg";